module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-1-1-7d3aed63f792c9089053167811883427.jpg";